export interface RadioProfileConfig {
  logo: string;
  cover: string;
  description: string;
  radioName: string;
  category: string;
  language: string;
  frequencyRfw: string;
  frequencyNum: string;
  webUrl: string;
  email: string;
  phone: string;
  whatsapp: string;
  address: string;
  city: string;
  country: string;
  socials: ProfileSocial[];
  showEmail: boolean;
  showPhone: boolean;
  showWhatsapp: boolean;
}

export interface ProfileSocial {
  id: string;
  platform: string;
  url: string;
  icon: string;
  active: boolean;
}

export const defaultProfileConfig: RadioProfileConfig = {
  logo: 'https://readdy.ai/api/search-image?query=Modern%20radio%20station%20logo%20design%2C%20minimalist%20circular%20emblem%2C%20warm%20coral%20and%20cream%20colors%2C%20sound%20wave%20and%20broadcast%20tower%20motif%2C%20clean%20professional%20brand%20identity%2C%20elegant%20typography%2C%20soft%20gradient%20background&width=200&height=200&seq=profile-logo-default&orientation=squarish',
  cover: 'https://readdy.ai/api/search-image?query=Radio%20station%20cover%20art%20background%2C%20warm%20ambient%20lighting%20with%20abstract%20sound%20waves%2C%20coral%20and%20amber%20gradient%20tones%2C%20modern%20minimalist%20aesthetic%2C%20audio%20broadcasting%20theme%2C%20soft%20elegant%20atmosphere%2C%20dark%20overlay%20subtle%20texture&width=1600&height=400&seq=profile-cover-default&orientation=landscape',
  description: 'La mejor música latina y los éxitos del momento. Transmitiendo desde Santa Rosa, Guatemala para todo el mundo. Programas en vivo, entrevistas exclusivas y la mejor selección de pop, rock y música regional.',
  radioName: 'Radio Nueva Actitud',
  category: 'Música',
  language: 'Español',
  frequencyRfw: '102.5 RFW',
  frequencyNum: '102.5',
  webUrl: 'https://radioactitud.com',
  email: 'contacto@radioactitud.com',
  phone: '+502 5555 1234',
  whatsapp: '+502 5555 1234',
  address: 'Av. Central 456, Zona 1',
  city: 'Santa Rosa',
  country: 'Guatemala',
  socials: [
    { id: 'facebook', platform: 'Facebook', url: 'https://facebook.com/radioactitud', icon: 'ri-facebook-fill', active: true },
    { id: 'instagram', platform: 'Instagram', url: 'https://instagram.com/radioactitud', icon: 'ri-instagram-fill', active: true },
    { id: 'twitter', platform: 'X (Twitter)', url: 'https://x.com/radioactitud', icon: 'ri-twitter-x-fill', active: true },
    { id: 'youtube', platform: 'YouTube', url: 'https://youtube.com/@radioactitud', icon: 'ri-youtube-fill', active: true },
    { id: 'tiktok', platform: 'TikTok', url: 'https://tiktok.com/@radioactitud', icon: 'ri-tiktok-fill', active: true },
    { id: 'spotify', platform: 'Spotify', url: 'https://open.spotify.com/show/radioactitud', icon: 'ri-spotify-fill', active: false },
    { id: 'whatsapp', platform: 'WhatsApp', url: '', icon: 'ri-whatsapp-fill', active: false },
    { id: 'discord', platform: 'Discord', url: 'https://discord.gg/radioactitud', icon: 'ri-discord-fill', active: false },
    { id: 'twitch', platform: 'Twitch', url: '', icon: 'ri-twitch-fill', active: false },
    { id: 'telegram', platform: 'Telegram', url: '', icon: 'ri-telegram-fill', active: false },
  ],
  showEmail: true,
  showPhone: true,
  showWhatsapp: true,
};